export * from "./cases";
export * from "./getColumnsFromDataSource";
export * from "./grammar";
export * from "./actionsWithLoading";
export * from "./arrays";
export * from "./string";
export * from "./voiceCall";
export * from "./teamValidation";

export const heicToJpg = mediaUrl => {
  return (mediaUrl || "").replace(/\.heic$/i, ".jpg").replace(/\.heif$/i, ".jpg");
};
